import { useAddFinancialDocumentToImporterMutation } from "@api/financialDocument.api";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { useContext } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { useNotifyUnfinishedImport } from "@components/importer/useNotifyUnfinishedImport";
import { AccrualImporterContext } from "./accrualImporter.context";
import { getAccrualImporterDocumentEligibility } from "./accrualImporterDocumentEligibility";

interface Props {
    financialDocument: FinancialDocumentListItem;
}

export const AccrualImporterPickExistingDocumentCta: React.FC<Props> = ({
    financialDocument,
}) => {
    const { mode, importerQueue } = useContext(AccrualImporterContext);
    const { isAlreadyAdded, isDisabled, disabledTooltip } =
        getAccrualImporterDocumentEligibility({
            financialDocument,
            importerQueue,
        });
    const notifyUnfinishedImport = useNotifyUnfinishedImport(mode);

    const addToImporter = useAddFinancialDocumentToImporterMutation({
        financialDocument,
        importerQueue,
        onSuccess: (updatedDocument) =>
            notifyUnfinishedImport([updatedDocument]),
    });

    return (
        <Tooltip content={disabledTooltip}>
            <ButtonWithLoader
                variant="primary"
                size="sm"
                loading={addToImporter.isPending}
                onClick={() => {
                    addToImporter.mutate();
                }}
                disabled={isDisabled}
            >
                {isAlreadyAdded ? "Added" : "Add"}
            </ButtonWithLoader>
        </Tooltip>
    );
};
